module.exports = __webpack_public_path__ + "static/toilet.aa5c2793.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/toilet.m4a
// module id = 126
// module chunks = 105603797122985 114276838955818 126609682503911 252234152318474